import { createContext, FC, ReactNode, useState } from 'react';
import { FilterPlatformEnum } from '../api/dashboard/enums/filter-platform.enum';

type AppContext = {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  startDate: Date;
  endDate: Date;
  setEndDate: (date: Date) => void;
  setStartDate: (date: Date) => void;
  prevEndDate: Date;
  prevStartDate: Date;
  setPrevStartDate: (date: Date) => void;
  setPrevEndDate: (date: Date) => void;
  platform: FilterPlatformEnum;
  setPlatform: (platform: FilterPlatformEnum) => void;
};

export const context = createContext<AppContext>({} as AppContext);

export const SidebarProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState<boolean>(false);
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [prevEndDate, setPrevEndDate] = useState<Date>(new Date());
  const [prevStartDate, setPrevStartDate] = useState<Date>(new Date());
  const [platform, setPlatform] = useState<FilterPlatformEnum>(
    FilterPlatformEnum.All
  );
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  return (
    <context.Provider
      value={{
        sidebarToggle,
        toggleSidebar,
        closeSidebar,
        endDate,
        startDate,
        setStartDate,
        setEndDate,
        prevEndDate,
        prevStartDate,
        setPrevEndDate,
        setPrevStartDate,
        platform,
        setPlatform
      }}
    >
      {children}
    </context.Provider>
  );
};
